import { VueExtension } from "../../utils/extensions/vue";
import SwiperItem from './swiperitem.jsx'
import './swiperitem.scss'

VueExtension.WithInstall(SwiperItem)

export default SwiperItem